"use strict";

window._theme = window._theme || {};

_theme.Helpers = (function(){
    function getParamFromURL(param, _url){
        if(!_url) _url = window.location.href;
    
        var url = new URL(_url);
        var search_params = url.searchParams;
        var paramVal = search_params.get(param);
    
        return paramVal;
    }
    function setItemIntoLS(key, value){
        if(typeof localStorage === undefined || typeof localStorage === null) return;
        if(typeof value !== 'string'){
          value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
        return true;
    }
    function getItemFromLS(key){
        if(typeof localStorage === undefined || typeof localStorage === null) return;
        let value = localStorage.getItem(key);
        return JSON.parse(value);
    }
    function removeItemFromLS(key){
        if(typeof localStorage === undefined || typeof localStorage === null) return;
        localStorage.removeItem(key);
        return true;
    }
    function updateHtml(html, str, data){
        var newHtml = html;
        if(newHtml.indexOf(str) > -1){
          newHtml = newHtml.replace(str, data);
          return updateHtml(newHtml, str, data);
        } else {
          return newHtml;
        }
    }
    function showLoader(show){
        const loader = document.querySelector('[data-custom-loader]');
        if(!loader) return;
        loader.setAttribute('aria-hidden', !show);
    }
    function refreshReview(){
        window.yotpo && window.yotpo.refreshWidgets(); // Re-init yotpo reviews
    }
    function handleize(str = ''){
        return str.toString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    function showToastMsg(msg, delay){
        const toastModel = document.querySelector('[data-toast-notify]');
        if(!toastModel || !msg) return;
        toastModel.querySelector('[data-toastmsg]').innerHTML = msg;
        toastModel.setAttribute('aria-hidden', false);
        setTimeout(function(){
            toastModel.setAttribute('aria-hidden', true);
        }, delay || 3000);
    }
    function validateEmail(email){
        return /\S+@\S+\.\S+/.test(email || '');
    }
    function resizeImage(imgUrl, size) {
        try {
            if ("original" == size)
                return imgUrl;
            var e = imgUrl.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
            return e[1] + "_" + size + "." + e[2]
        } catch (o) {
            return imgUrl
        }
    }

    return {
        getParamFromURL: getParamFromURL,
        setItemIntoLS: setItemIntoLS,
        getItemFromLS: getItemFromLS,
        removeItemFromLS: removeItemFromLS,
        updateHtml: updateHtml,
        showLoader: showLoader,
        refreshReview: refreshReview,
        handleize: handleize,
        setCookie: setCookie,
        getCookie: getCookie,
        eraseCookie: eraseCookie,
        showToastMsg: showToastMsg,
        validateEmail: validateEmail,
        resizeImage: resizeImage
    }
})();

_theme.MakeCollection = (function(){
    const selectors = {
        makeContainer: document.querySelector('.make'),
        makeProductsContainer: document.querySelector('[data-make-products]'),
        makeVideoModal: document.querySelector('[data-make-video-modal]'),
        makeVideoModalClose: document.querySelector('[data-make-video-modal] .close'),
        makeVideoModalTitle: document.querySelector('[data-make-video-modal] .make-video-title'),
        makeVideoModalIframe: document.querySelector('[data-make-video-modal] iframe'),
        makeVideoModalImage: document.querySelector('[data-make-video-modal] .image-container img'),
        makeVideoModalPdf:document.querySelector('[data-make-video-modal] .make-pdf'),
        makeVideoModalNRC: document.querySelector('[data-make-video-modal] [data-make-nrc]'),
        makeRelatedProduct: document.querySelector('[data-make-video-modal] [data-make-related-products]'),
        makeFilters: document.querySelector('[data-make-filters]'),
        makeFilterModalToggle: document.querySelectorAll('[data-filter-toggle]'),
        makePagination: document.querySelector('[data-make-pagination]'),
        makeFilterModal: document.querySelector('.make .make-products-col-left'),
        closeMakeFilterModal: document.querySelectorAll('[data-close-make-filters]'),
        filteredProductCount: document.querySelector('[data-view-btn] span'),
        klaviyoModel: document.querySelector('[data-klaviyo-notify]')
    };

    const attributes = {
        strYearRegex: /\B(?=[A-Z])|\s*\d{4}\b/g,
        pageTitle: '',
        PRODUCTS_BASE_URL: 'https://pureflow.pgiproduct.com/api/v1/getProductsBymake',
        Sku_Base_Products_URL: 'https://pureflow.pgiproduct.com/api/v1/getProductBySku',
        Youtube_Image_URL: 'https://i.ytimg.com/vi/[[YouTube_Id]]/hqdefault.jpg',
        preload_img_url: _theme.settings.imgLoadingURL,
        PRODUCTS_VIEW_URL: '/?view=__DoNotUse__',
        PRODUCTS_LS_KEY: '_mkv',
        showOnlyVideoProducts: _theme.settings.showOnlyVideoProducts,
        minModelYear: _theme.settings.minModelYear || 0,
        productPdfThumbImg: _theme.settings.productPdfThumbImg || null,
        makeNRCPageURL: _theme.settings.nrcPageUrl,
        filterLogic: 'or',
        PRODUCTS_LS_KEY_DURATION: _theme.settings.sessionDuration < 1 ? 0 : Math.abs(_theme.settings.sessionDuration/24),
        Youtube_Embed_URL: 'https://www.youtube.com/embed/',
        PureFlowMake404_URL: '/pages/not-available-in-pureflow',
        hideClass: 'hide',
        scrollStopClass: 'scroll-stop',
        pagination: {
            currentPage: 1,
            totalPages: 1,
            productsPerPage: (window.innerWidth > 767) ? 15 : 16,
            tabLimit: 5,
            pages: {}
        },
        filteredProductCount:0,
        totalProducts: 0,
        requestPerPageLimit: 20,
        makeProducts: [],
        makeFilteredProducts: [],
        makeSkuProducts: {},
        productGridLayout: _theme.html.productGrid,
        noProductsMsg: _theme.settings.noResultText || 'The vehicle you’ve specified was not factory equipped with a cabin air filter.', //'No Products Found',
        noProductsImg: _theme.settings.noResultImg || 'https://cdn.shopify.com/s/files/1/0445/2817/3216/files/napf_b0d68384-e04e-4160-9065-2c2d4793b8fd.jpg',
        noProductsClass: 'make-empty',
        noResultClass: 'make-no-result',
        noImageURL: 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif',
        productGridHtml: `<div class="make-product" tabindex="0" data-id="[[PRODUCT_ID]]">
                            <figure>
                                <div class="bg-img" style="background-image: url([[PRODUCT_IMAGE_URL]]);"></div>
                                <figcaption>[[PRODUCT_TITLE]]</figcaption>
                            </figure>
                         </div>`,
        filterItemHtml: `<div class="make-filter-item" data-title="[[FILTER_HEADING]]">
                            <div class="make-filter-item-heading">[[FILTER_HEADING]]</div>
                                <div class="make-filter-item-options">
                                <form autocomplete="off"><label><input class="form-control" type="search" name="search" placeholder="Search options" /></label></form>
                                [[FILTER_OPTIONS]]
                            </div>
                        </div>`,
        filterItemOptionHtml: `<li data-value="[[INPUT_TEXT_HANDLEIZE]]">
                                <input id="[[INPUT_ID]]" type="checkbox" name="[[INPUT_TEXT_HANDLEIZE]]" value="[[INPUT_TEXT]]" autocomplete="off" />
                                <label for="[[INPUT_ID]]">[[INPUT_TEXT]]</label>
                            </li>`
    };

    function MakeCollection(){
        const make = _theme.Helpers.getParamFromURL('make');
        if(!make) {
            this.renderNoProductsLayout();
            return;
        }

        if(attributes.PRODUCTS_LS_KEY_DURATION <= 0) _theme.Helpers.eraseCookie(attributes.PRODUCTS_LS_KEY);
        const hasToken = _theme.Helpers.getCookie(attributes.PRODUCTS_LS_KEY);
        if(!hasToken){
            _theme.Helpers.removeItemFromLS(attributes.PRODUCTS_LS_KEY);
            if(attributes.PRODUCTS_LS_KEY_DURATION > 0) _theme.Helpers.setCookie(attributes.PRODUCTS_LS_KEY, 'true', attributes.PRODUCTS_LS_KEY_DURATION);
        }

        this.make = make;
        attributes.pageTitle = `${make} Cabin Air Filter Installation Guides`;
        this.init();
        delete _theme.html;
        delete _theme.settings;
    }

    MakeCollection.prototype.init = function(){
        // _theme.Helpers.setCookie();
        _theme.Helpers.showLoader(1);
        const savedMakes = this.getSavedData() || {};
        
        if(!savedMakes || !savedMakes[this.make] || !savedMakes[this.make].products){
            this.initiateRequests();
            return;
        }

        const allProducts = savedMakes[this.make].products;
        const { models = [], years = [] } = savedMakes[this.make];
        if(allProducts.length === 0){
            this.renderNoProductsLayout();
            return;
        }

        attributes.makeFilteredProducts = allProducts;
        attributes.pagination.products = allProducts;
        this.buildFilter({years, models});
        this.buildPagination(attributes.makeFilteredProducts);
        
        const {products} = attributes.pagination.pages[attributes.pagination.currentPage];
        if(!products || products.length === 0){
            this.renderNoProductsLayout();
            return;
        }

        this.buildMakeProductsGrid(products);
        this.updateFilteredProductsCount(attributes.makeFilteredProducts.length);
        this.initKlaviyoModalEvents();
        _theme.Helpers.showLoader();
    }

    MakeCollection.prototype.initiateRequests = async function(){
        const savedMakes = this.getSavedData() || {};
        savedMakes[this.make] = savedMakes[this.make] || {};

        try {
            const resp = await this.fetchMakeProducts();
            if(!resp.status || !resp.response || resp.response.length === 0){
                savedMakes[this.make]['products'] = resp.response || [];
                this.saveData(savedMakes);
                this.renderNoProductsLayout();
                return;
            }
            
            selectors.makeContainer.classList.remove(
                attributes.noProductsClass,
                attributes.noResultClass
            );
            attributes.makeProducts = resp.response;

            // const products = await this.fetchProductsMetaByView(resp.response);
            let products = await this.filterAndExtendMakeProducts(resp.response);
            if(attributes.showOnlyVideoProducts) products = products.filter(p => p.youtube_video_id);
            if(attributes.minModelYear) products = products.filter(p => Number(p.year) >= attributes.minModelYear);
            if(products.length === 0){
                savedMakes[this.make]['products'] = [];
                this.saveData(savedMakes);
                this.renderNoProductsLayout();
                return;
            }

            attributes.makeFilteredProducts = products;
            attributes.pagination.products = products;
            savedMakes[this.make]['products'] = products;
            savedMakes[this.make]['models'] = resp.modelList || [];
            savedMakes[this.make]['years'] = resp.yearListAbove2000 || [];
            this.saveData(savedMakes);

            this.buildFilter({ years: resp.yearListAbove2000 || [], models: resp.modelList || [] });
            this.buildPagination(products);
            const {products: pageProducts} = attributes.pagination.pages[attributes.pagination.currentPage];
            if(!pageProducts || pageProducts.length === 0){
                this.renderNoProductsLayout();
                return;
            }
            this.buildMakeProductsGrid(pageProducts);
            this.updateFilteredProductsCount(products.length);
            this.initKlaviyoModalEvents();
            _theme.Helpers.showLoader();
        } catch(err){
            _theme.Helpers.showToastMsg('Something went wrong, Try again by reloading the page');
            console.error(err);
            _theme.Helpers.showLoader();
        }
    }

    MakeCollection.prototype.renderNoProductsLayout = function(hideFilter = true){
        selectors.makeContainer.classList.remove(attributes.noProductsClass,attributes.noResultClass);
        if(hideFilter) selectors.makeContainer.classList.add(attributes.noProductsClass);
        else selectors.makeContainer.classList.add(attributes.noResultClass);
        // selectors.makeProductsContainer.innerHTML = `<p class="make-empty-msg">${attributes.noProductsMsg}</p>`;
        selectors.makeProductsContainer.innerHTML = `
            <div class="mk-no-result">
                <img class="lazyload" data-sizes="auto" sizes="370px" width="351" height="185" src="${attributes.preload_img_url}" data-src="${attributes.noProductsImg}" alt="no products found" />
                <p>${attributes.noProductsMsg}</p>
            </div>
        `
        _theme.Helpers.showLoader();
    }

    MakeCollection.prototype.initYoutubeScript = function(){
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        this.players = null;
    }

    MakeCollection.prototype.fetchMakeProducts = async function(){
        if(!this.make) throw new Error('Make is mandatory');
        
        const formData = new FormData();
        formData.append('termMake', this.make);
        const res = await fetch(attributes.PRODUCTS_BASE_URL, {
            method: 'post',
            mode: 'cors',
            body: formData
        });
        const data = await res.json();

        return data;
    }

    MakeCollection.prototype.fetchProductsMetaByView = async function(products){
        if(!products || products.length === 0) throw new Error('Invalid or No products to make request');
        if(products.length > attributes.requestPerPageLimit) throw new Error(`Maximum ${attributes.requestPerPageLimit} requests allowed at a time`);
        
        const handles = products.map(p => p.handle);
        const fetchProductsURL = attributes.PRODUCTS_VIEW_URL + '&make=' + handles.join(',');
        const productRes = await fetch(fetchProductsURL);
        const result = await productRes.json();

        if(!result.products || result.products.length === 0) throw new Error('No products meta data found');
        result.products = result.products.map(product => {
            const matchProduct = products.find(p => p.product_id == product.product_id);
            return {...product, ...matchProduct};
        });
        
        return result.products;
    }

    MakeCollection.prototype.fetchProductsBySku = async function(sku){
        if(!sku){
            console.error('Invalid SKU');
            return {status: false, msg: 'Invalid SKU'}
        }

        const formData = new FormData();
        formData.append('product_sku', sku);
        formData.append('termMake', this.make);
        const res = await fetch(attributes.Sku_Base_Products_URL, {
            method: 'post',
            mode: 'cors',
            body: formData
        });
        const data = await res.json();

        return data;
    }

    MakeCollection.prototype.filterAndExtendMakeProducts = async function(products){
        if(!products) throw new Error('Invalid products data');

        const totalRequestCount = Math.ceil(products.length / attributes.requestPerPageLimit);
        let startIndex = 0, endIndex = attributes.requestPerPageLimit;
        const requestQueue = []; let filteredProducts = [];
        for(let i = 0; i < totalRequestCount; i++){
            startIndex = i * attributes.requestPerPageLimit;
            endIndex = startIndex + attributes.requestPerPageLimit;
            const productsChunk = products.slice(startIndex, endIndex);
            if(productsChunk.length === 0) break;
            const handles = productsChunk.map(p => p.handle);
            const fetchProductsURL = attributes.PRODUCTS_VIEW_URL + "&variant=" + new Date().getTime() + '&make=' + handles.join(',')
            requestQueue.push(fetch(fetchProductsURL));
        }

        const results = await Promise.allSettled(requestQueue);
        for (const result of results) {
            if (result.status !== 'fulfilled') continue;
            // const datatext = await result.value.text();
            // console.log('datatext', datatext);
            const data = await result.value.json();
            const extendedProductsChunk = data.products.map(product => {
                const matchProduct = products.find(p => p.product_id == product.product_id);
                return {...product, ...matchProduct};
            });

            filteredProducts = [...filteredProducts, ...extendedProductsChunk];
        }

        return filteredProducts;
    }

    MakeCollection.prototype.buildFilter = function(filters){
        const filterKeys = Object.keys(filters);
        if(filterKeys.length === 0) return;

        attributes.filters = filterKeys.map(key => {
            let options = filters[key].map(({modelname, yearid}) => modelname || yearid).sort();
            if(key === 'years') {
                options = options.filter(option => (Number(option) > attributes.minModelYear));
                options.reverse();
            }
            return {name: key, key: key.replace('s',''), options}
        });

        // attributes.models = attributes.makeFilteredProducts.filter(p => p.model);
        // attributes.years = attributes.makeFilteredProducts.filter(p => p.year);
        // attributes.models = Array.from(new Set(attributes.makeFilteredProducts.map(p => p.model))).sort();
        // attributes.years = Array.from(new Set(attributes.makeFilteredProducts.map(p => p.year))).sort().reverse();
        // if(attributes.models.length === 0 && attributes.years.length === 0) return;
        // const filters = [
        //     { name: 'Year', options: attributes.years },
        //     { name: 'Model', options: attributes.models }
        // ];
        
        let filterItemsHtml = '';
        attributes.filters.forEach(filter => {
            let itemHtml = attributes.filterItemHtml;
            itemHtml = _theme.Helpers.updateHtml(itemHtml, '[[FILTER_HEADING]]', filter.key);
            let optionsHtml = '';
            filter.options.forEach(option => {
                let optionHtml = attributes.filterItemOptionHtml;
                optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[INPUT_ID]]', `${filter.name}-${option}`);
                optionHtml = _theme.Helpers.updateHtml(
                    optionHtml, '[[INPUT_TEXT_HANDLEIZE]]', _theme.Helpers.handleize(option)
                );
                optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[INPUT_TEXT]]', option);
                optionsHtml += optionHtml;
            });

            itemHtml = _theme.Helpers.updateHtml(itemHtml, '[[FILTER_OPTIONS]]', `<ul class="scroller">${optionsHtml}</ul>`);
            filterItemsHtml += itemHtml;
        });

        selectors.makeFilters.innerHTML = filterItemsHtml;
        selectors.makeFilterModal.querySelector('.make-filter-inner').classList.remove(attributes.hideClass);
        this.initMakeFilterEvents();
    }

    MakeCollection.prototype.buildMakeProductsGrid = function(products){
        if(!products) throw new Error('Invalid Products Data');
        this.initMakeProductEvents(true);
        let mainHtml = '';
        products.forEach(product => {
            let productHtml = attributes.productGridHtml;
            let Youtube_Image_URL = attributes.Youtube_Image_URL;
            let pImgURL = attributes.productPdfThumbImg; // _theme.Helpers.resizeImage(product.image_url, '300x');
            if(product.pdf && product.pdf !== '' & product.pdf.includes('?v=')) pImgURL = attributes.productPdfThumbImg || pImgURL;
            if(pImgURL.includes('/no-image-')) pImgURL = attributes.productPdfThumbImg || pImgURL;
            const youtubeId = product.youtube_video_id.replace('https://youtu.be/','');
            const posterImgURL = 
            youtubeId ? _theme.Helpers.updateHtml(Youtube_Image_URL, '[[YouTube_Id]]', youtubeId) : pImgURL;
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_IMAGE_URL]]', attributes.productPdfThumbImg);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_TITLE]]', product.year_range_title || product.product_title);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_ID]]', product.product_id);
            mainHtml += productHtml;
        });

        selectors.makeProductsContainer.innerHTML = mainHtml;
        this.initMakeProductEvents();
    }

    MakeCollection.prototype.buildProductsGrid = function(products){
        if(!products || !attributes.productGridLayout){
            console.error('Invalid products data or Product layout html');
            return;
        }

        this.initMakeModalEvents(true);
        let mainHtml = '';
        products.forEach(product => {
            let productHtml = attributes.productGridLayout;
            // attributes.strYearRegex
            var productTitle = product.product_title.replace(/\d{4}/, match => match ? "" : " ");
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_URL]]', `/products/${product.handle}`);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_TITLE]]', productTitle);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_ID]]', product.product_id);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[REVIEW_PRODUCT_ID]]', product.review_product_id || product.product_id);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[VARIANT_ID]]', product.variant_id);
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[IMAGE_SWAP_CLASS]]', product.images.length > 1 ? 'image-swap' : '');
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_IMAGES]]', buildProductImage(product));
            productHtml = _theme.Helpers.updateHtml(productHtml, '[[PRODUCT_PRICE]]', buildProductPrice(product));
            if(product.available) {
                productHtml = _theme.Helpers.updateHtml(productHtml, '[[ATC_CLASS]]', '');
                productHtml = _theme.Helpers.updateHtml(productHtml, '[[BIS_CLASS]]', 'hide');
            } else {
                productHtml = _theme.Helpers.updateHtml(productHtml, '[[ATC_CLASS]]', 'hide');
                productHtml = _theme.Helpers.updateHtml(productHtml, '[[BIS_CLASS]]', '');
            }
            mainHtml += productHtml;
        });

        selectors.makeRelatedProduct.innerHTML = '';
        selectors.makeRelatedProduct.innerHTML = mainHtml;
        _theme.Helpers.refreshReview();
        initSlider();
        this.initMakeModalEvents();

        function buildProductImage(product){
            let html = `<img
                        class="lazyload ${product.images.length > 1 && 'product-card__img image-one' }"
                        src="${attributes.preload_img_url}"
                        data-src="${product.image_url || attributes.noImageURL}"
                        data-sizes="auto"
                        alt="${product.product_title}"
                        sizes="370px"
                    />`;
            if(product.images.length > 1){
                html += `<img class="image-two lazyautosizes lazyloaded" src="${product.images[1]}" data-src="${product.images[1]}" data-sizes="auto" alt="${product.product_title}" data-image="" sizes="383px">`
            }
            
            return html;
        }

        function buildProductPrice(product){
            var priceText = product.cv_price || (product.product_price != null && product.product_price !== '' && product.product_price !== 'null'
                ? (String(product.product_price).indexOf('$') === 0 ? product.product_price : ('$' + product.product_price))
                : '');
            if (!priceText || priceText === '$null' || priceText === 'null' || priceText === '$undefined') {
                return '<div class="product-price" data-price="" style="display:none;"></div>';
            }
            let html = `<div class="product-price " data-price="">      
                            <span class="price-item price-item--regular" data-regular-price="">${priceText}</span>
                        </div>`;
            return html;
        }

        function initSlider(){
            selectors.makeRelatedProduct.classList.remove('slick-slider','slick-initialized', 'no-slick');
            if(products.length < 3) selectors.makeRelatedProduct.classList.add('no-slick');
            const $slider = $(selectors.makeRelatedProduct);
            // if($slider.hasClass('slick-initialized')) $slider.slick('unslick');

            $slider.slick({
                infinite: false,
                dots:false,
                arrows: true,
                slidesToShow: 3,
                prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"/></svg></div>', 
                nextArrow: '<div class="slick-next"><svg style="transform:rotate(180deg);" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"/></svg></div>',
                responsive: [
                  {
                    breakpoint: 991,
                    settings: {
                      slidesToShow: 2
                    }
                  },
                  {
                    breakpoint: 575 ,
                    settings: {
                      slidesToShow: 1
                    }
                  }
                ]
            });
        }
    }

    MakeCollection.prototype.buildPagination = function(products){
        if(!products || !Array.isArray(products)) throw new Error('Invalid products');
        const { pagination: { productsPerPage } } = attributes;
        // if(products.length <= productsPerPage) return;

        const totalPages = Math.ceil(products.length / productsPerPage);
        let pages = {};
        attributes.pagination.totalPages = totalPages;
        attributes.pagination.products = products;
        for(let i = 0; i < totalPages; i++){
            const startIndex = i * productsPerPage;
            const endIndex = startIndex + productsPerPage;
            const pageProducts = products.slice(startIndex, endIndex);
            const pageIndex = i + 1;
            pages[pageIndex] = pages[pageIndex] || {};
            pages[pageIndex]['products'] = pages[pageIndex]['products'] || [];
            pages[pageIndex]['products'] = pageProducts;
        }

        attributes.pagination.pages = pages;
        this.buildPaginationHtml(products);
    }

    MakeCollection.prototype.buildPaginationHtml = function(products){
        if(!products || !Array.isArray(products)) throw new Error('Invalid products');
        if(products.length <= attributes.pagination.productsPerPage){
            selectors.makePagination.classList.add(attributes.hideClass);
            return;
        }
        
        this.initMakePaginationEvents(true);
        const totalPages = Math.ceil(products.length / attributes.pagination.productsPerPage);
        const {pagination: {currentPage}} = attributes;
        let pagiTabs = '', { pagination:{ tabLimit } } = attributes; 
        let mainHtml = '';
        if(totalPages <= tabLimit){
            pagiTabs = getPagiItemHtml(1,totalPages);
        } else {
            const firstDiff = currentPage - 2;
            const lastDiff = totalPages - currentPage;
            const nextTabs = currentPage + 2;
            pagiTabs = getPagiAdditionalHtml(true, false);
            if(firstDiff < 3){
                pagiTabs += getPagiItemHtml(1,tabLimit, true);
                pagiTabs += getPagiItemHtml(totalPages,totalPages);
            } else if(lastDiff === 0){
                pagiTabs += getPagiItemHtml(1,1, true);
                pagiTabs += getPagiItemHtml(currentPage - 2, currentPage - 1);
                pagiTabs += getPagiItemHtml(currentPage, currentPage);
            } else if(lastDiff === 1){
                pagiTabs += getPagiItemHtml(1,1, true);
                pagiTabs += getPagiItemHtml(currentPage - 2, currentPage - 1);
                pagiTabs += getPagiItemHtml(currentPage, currentPage);
                pagiTabs += getPagiItemHtml(totalPages,totalPages);
            } else if(lastDiff === 2) {
                pagiTabs += getPagiItemHtml(1,1, true);
                pagiTabs += getPagiItemHtml(currentPage - 2, currentPage - 1);
                pagiTabs += getPagiItemHtml(currentPage, currentPage);
                pagiTabs += getPagiItemHtml(currentPage + 1, currentPage + 2);
            } else {
                pagiTabs += getPagiItemHtml(1,1, true);
                pagiTabs += getPagiItemHtml(currentPage - 2, currentPage - 1);
                pagiTabs += getPagiItemHtml(currentPage, currentPage);
                pagiTabs += getPagiItemHtml(currentPage + 1, currentPage + 2, true);
                pagiTabs += getPagiItemHtml(totalPages,totalPages);
            }
            pagiTabs += getPagiAdditionalHtml(false,true);
        }

        mainHtml = `<ul>${pagiTabs}</ul>`;
        
        selectors.makePagination.innerHTML = mainHtml;
        this.updatePagiBtnStatus(currentPage, totalPages);
        this.initMakePaginationEvents();
        selectors.makePagination.classList.remove(attributes.hideClass);

        function getPagiItemHtml(startIndex, endIndex, addSeparator){
            let btnHtml = '';
            for(let i = startIndex; i <= endIndex; i++){
                let activeClass = '';
                if(currentPage === i) activeClass = 'active';
                btnHtml += `<li class="${activeClass}"><button data-page="${i}" class="border btn btn-outline-dark make-pagination-btn ${activeClass}" aria-current="${currentPage === i}" type="button" aria-label="go to page ${i}">${i}</button></li>`;
            }

            if(addSeparator){
                btnHtml += `<li><button class="border btn btn-outline-dark make-pagination-btn separator" aria-current="false" type="button" tabindex="-1">...</button></li>`;
            }

            return btnHtml;
        }
        function getPagiAdditionalHtml(isStart, isEnd){
            let html = '';
            if(isStart && !isEnd){
                html = '<li class="pagi-first"><button data-page="first" class="border btn btn-outline-dark make-pagination-btn" type="button" aria-label="go to page 1">First</button></li>';
                html += `<li class="pagi-prev">
                        <button data-page="prev" class="border btn btn-arrow border btn-outline-dark make-pagination-btn" type="button" aria-label="go to previous page">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 370.814 370.814"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                        </button>
                        </li>`;
            }
            if(isEnd && !isStart){
                html = `<li class="pagi-prev">
                        <button data-page="next" class="border btn btn-arrow btn-outline-dark make-pagination-btn" type="button" aria-label="go to next page">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 478.448 478.448"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                        </button>
                        </li>`;
                html += '<li class="pagi-last"><button data-page="last" class="border btn btn-outline-dark make-pagination-btn" type="button" aria-label="go to page 1">Last</button></li>';
            }

            return html;
        }
    }

    MakeCollection.prototype.initMakeProductEvents = function(shouldDestroy){
        selectors.makeProducts = 
        shouldDestroy ? Array.from(selectors.makeProducts || '') : 
        selectors.makeProductsContainer.querySelectorAll('.make-product');
        // console.log(selectors.makeProducts);
        selectors.makeProducts.forEach(productElem => {
            if(shouldDestroy) productElem.removeEventListener('click', this.openProductDetailsModal.bind(this));
            else productElem.addEventListener('click', this.openProductDetailsModal.bind(this));
        });

        if(shouldDestroy) selectors.makeVideoModalClose.removeEventListener('click', this.closeProductDetailsModal.bind(this));
        else selectors.makeVideoModalClose.addEventListener('click', this.closeProductDetailsModal.bind(this));

        selectors.closeMakeFilterModal.forEach(btn => {
            if(shouldDestroy) btn.removeEventListener('click', closeFilterModal);
            else btn.addEventListener('click', closeFilterModal);
        });
        
        function closeFilterModal(){
            selectors.makeFilterModal.classList.remove('open');
            document.documentElement.classList.remove(attributes.scrollStopClass);
        }
    }

    MakeCollection.prototype.initMakeFilterEvents = function(){
        const self = this;
        selectors.makeFilterSearchInputs = document.querySelectorAll('[data-make-filters] input[name="search"]');
        selectors.makeFilterOptionInputs = document.querySelectorAll('[data-make-filters] .make-filter-item-options input[type="checkbox"]');
        
        selectors.makeFilterSearchInputs.forEach(searchInput => {
            searchInput.removeEventListener('keyup', handleSearchInput);
            searchInput.addEventListener('keyup', handleSearchInput);
        });

        selectors.makeFilterOptionInputs.forEach(optionInput => {
            optionInput.removeEventListener('change', handleOptionInput);
            optionInput.addEventListener('change', handleOptionInput);
        });

        selectors.makeFilterModalToggle.forEach(button => {
            button.removeEventListener('click', toggleFilter);
            button.addEventListener('click', toggleFilter);
        });
        
        function handleSearchInput(evt){
            const parent = this.closest('.make-filter-item-options');
            if(!parent) return;
            const term = _theme.Helpers.handleize(this.value);
            const matchedItems = parent.querySelectorAll(`ul > li[data-value*="${term}"]`);
            const notMatchedItems = parent.querySelectorAll(`ul > li:not([data-value*="${term}"])`);
            notMatchedItems.forEach(item => {
                if(term) item.classList.add(attributes.hideClass);
                else item.classList.remove(attributes.hideClass)
            });
            matchedItems.forEach(item => item.classList.remove(attributes.hideClass));
        }

        function handleOptionInput(evt){
            _theme.Helpers.showLoader(1);
            let products = [];
            const mainParent = this.closest('[data-make-filters]');
            // let data = [];
            // const filterItems = mainParent.querySelectorAll('.make-filter-item');

            attributes.pagination.currentPage = 1; // Reset pagination, reset current page

            let selectedValues = Array.from(
                mainParent.querySelectorAll('.make-filter-item-options li > input[type="checkbox"]:checked')
            ).map(input => input.value.toLowerCase().trim());

            // filterItems.forEach(item => {
            //     const title = _theme.Helpers.handleize(item.dataset.title);
            //     const allCheckedInputs = Array.from(item.querySelectorAll('li > input[type="checkbox"]:checked'));
            //     const checkedValues = allCheckedInputs.map(input => input.value);
            //     if(checkedValues.length) data.push({title, options: checkedValues});
            // });

            if(selectedValues.length === 0) products = attributes.makeFilteredProducts.slice([]);
            else {
                products = attributes.makeFilteredProducts.filter(p => {
                    let {model, year, year_range_title} = p;
                    model = model ? model.toLowerCase().trim() : model;
                    year = year ? year.toLowerCase().trim() : year;
                    let status = false;
                    if((selectedValues.includes(model) || selectedValues.includes(year))) status = true;
                    if(year_range_title && !status){
                        year_range_title = year_range_title.toLowerCase().trim();
                        const matchTitle = selectedValues.find(val => year_range_title.includes(val));
                        if(matchTitle) status = true;
                        else {
                            const yearRange = year_range_title.split(' ')[0].split('-');
                            const minYear = Number(yearRange[1]);
                            const maxYear = Number(yearRange[0]);
                            const isInRange = selectedValues.find(val => {
                                const yearNumer = Number(val);
                                if(yearNumer && yearNumer >= minYear && yearNumer <= maxYear) return true;
                                return false;
                            });
                            if(isInRange) status = true;
                        }
                    }

                    return status;
                });
            }

            self.updateFilteredProductsCount(products.length);
            window.scrollTo({top: 0, behavior: 'smooth'});
            if(products.length === 0){
                selectors.makePagination.classList.add(attributes.hideClass);
                self.renderNoProductsLayout(false);
                return;
            }

            selectors.makePagination.classList.remove(attributes.hideClass);
            self.buildPagination(products);
            const {products: pageProducts} = attributes.pagination.pages[attributes.pagination.currentPage];
            if(!pageProducts || pageProducts.length === 0){
                self.renderNoProductsLayout();
                return;
            }

            selectors.makeContainer.classList.remove(
                attributes.noProductsClass,
                attributes.noResultClass
            );

            self.buildMakeProductsGrid(pageProducts);
            setTimeout(_theme.Helpers.showLoader, 500);
        }

        function toggleFilter(evt){
            selectors.makeFilterModal.classList.toggle('open');
            document.documentElement.classList.toggle(attributes.scrollStopClass);
        }
    }

    MakeCollection.prototype.initMakePaginationEvents = function(shouldDestroy){
        const self = this;
        selectors.pagiBtns = 
        shouldDestroy ? Array.from(selectors.pagiBtns || '') : 
        document.querySelectorAll('[data-make-pagination] .make-pagination-btn[data-page]');
        // console.log(selectors.pagiBtns);
        selectors.pagiBtns.forEach(btn => {
            if(shouldDestroy) btn.removeEventListener('click', handlePagiBtnClick);
            else btn.addEventListener('click', handlePagiBtnClick);
        });

        function handlePagiBtnClick(evt){
            const btn = evt.target;
            let pageNum;
            const { pagination: {currentPage, totalPages} } = attributes;
            const page = btn.dataset.page;
            if(page === 'first') pageNum = 1;
            if(page === 'prev') pageNum = currentPage - 1;
            if(page === 'next') pageNum = currentPage + 1;
            if(page === 'last') pageNum = totalPages;
            if(!isNaN(page)) pageNum = page;

            // console.log('pageNum', pageNum);
            if(!pageNum || pageNum < 1 || pageNum > totalPages || pageNum === currentPage) return;
            attributes.pagination.currentPage = Number(pageNum);
            btn.disabled = true;
            _theme.Helpers.showLoader(1);
            const {products} = attributes.pagination.pages[pageNum];
            if(!products || products.length === 0){
                self.renderNoProductsLayout();
                return;
            }
            self.buildMakeProductsGrid(products);
            self.buildPaginationHtml(attributes.pagination.products);
            self.updatePagiBtnStatus(pageNum, totalPages);
            // btn.disabled = false;
            setTimeout(_theme.Helpers.showLoader, 500);
        }
    }

    MakeCollection.prototype.initMakeModalEvents = function(shouldDestroy){
        selectors.notifyBtns = 
        shouldDestroy ? Array.from(selectors.notifyBtns || '') : 
        document.querySelectorAll('[data-make-video-modal] [data-btn-notify]');

        const modelPDFLinks = selectors.makeVideoModalPdf.querySelectorAll('a');

        modelPDFLinks.forEach(link => {
            if(shouldDestroy) link.removeEventListener('click', handlePDFClick.bind(this));
            else link.addEventListener('click', handlePDFClick.bind(this));
        });

        selectors.notifyBtns.forEach(btn => {
            if(shouldDestroy) btn.removeEventListener('click', handleNotifyMe.bind(this));
            else btn.addEventListener('click', handleNotifyMe.bind(this));
        });

        function handleNotifyMe(evt){
            const variant_id = evt.target.dataset.vid;
            const title = evt.target.dataset.title;
            this.openKlaviyoModel(title, variant_id);
        }

        function handlePDFClick(evt){
            const href = evt.target.href;
            if(!href) return;
            window.open(href, '_blank');
        }
    }

    MakeCollection.prototype.initKlaviyoModalEvents = function(){
        const closeModelBtns = selectors.klaviyoModel.querySelectorAll('.close, .klaviyo-bis-close');
        const modelForm = selectors.klaviyoModel.querySelector('form');
        const modelBtn = selectors.klaviyoModel.querySelector('[type="submit"]');
        const modelSuccess = selectors.klaviyoModel.querySelector('.form-success');
        const modelError = selectors.klaviyoModel.querySelector('.form-error');
        const emailInput = selectors.klaviyoModel.querySelector('[type="email"]');

        closeModelBtns.forEach(btn => btn.addEventListener('click', this.closeKlaviyoModel));
        modelForm.addEventListener('submit', async evt => {
            evt.preventDefault();
            let hasError = false, errorMsg = '';
            const variant_id = modelBtn.dataset.vid;
            const email = emailInput.value.trim();
            if(!email) {
                hasError = true;
                errorMsg = 'Email required';
            } else {
                hasError = !_theme.Helpers.validateEmail(email);
                errorMsg = hasError ? 'Invalid Email' : '';
            }
            if(hasError) {
                handleError(errorMsg);
                return;
            }

            resetForm();
            _theme.Helpers.showLoader(1);
            modelBtn.disabled = true;

            try{
                const data = await this.subscribeNotify(email, variant_id);
                if(data.success) handleSuccess();
                else handleError(data.message)
                _theme.Helpers.showLoader(false);
                modelBtn.disabled = false;
                setTimeout(resetForm, 5000);
            } catch(err){
                modelBtn.disabled = false;
                handleError('Error: ' + err.message);
                _theme.Helpers.showLoader(false);
                setTimeout(resetForm, 5000);
            }
        });

        function resetForm(){
            modelForm.classList.remove('error');
            modelError.classList.add('hide');
            modelSuccess.classList.add('hide');
            modelError.innerHTML = '';
        }

        function handleError(msg){
            modelSuccess.classList.add('hide');
            modelForm.classList.add('error');
            modelError.innerHTML = msg || 'Error';
            modelError.classList.remove('hide');
        }

        function handleSuccess(){
            emailInput.value = '';
            modelError.classList.add('hide');
            modelForm.classList.remove('error');
            modelSuccess.classList.remove('hide');
        }
    }

    MakeCollection.prototype.openKlaviyoModel = function(title, variant_id){
        if(!selectors.klaviyoModel || !title || !variant_id) return;
        selectors.klaviyoModel.querySelector('.klaviyo--title').innerHTML = title;
        selectors.klaviyoModel.querySelector('[type="submit"]').setAttribute('data-vid', variant_id);
        selectors.klaviyoModel.setAttribute('aria-hidden', false);
    }

    MakeCollection.prototype.closeKlaviyoModel = function(){
        if(!selectors.klaviyoModel) return;
        selectors.klaviyoModel.setAttribute('aria-hidden', true);
    }

    MakeCollection.prototype.subscribeNotify = async function(email, variant_id){
        if(!email || !variant_id) throw new Error('Email or Variant id is missing');
        const BASE_URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
        const formData = new FormData();
        formData.append('a', 'RjKqjG');
        formData.append('email', email);
        formData.append('variant', variant_id);
        formData.append('platform', 'api');
        const res = await fetch(BASE_URL, {
            method: 'post',
            mode: 'cors',
            body: formData
        });
        const data = await res.json();
        return data;
    }

    MakeCollection.prototype.updatePagiBtnStatus = function(currentPage, totalPages){
        currentPage = currentPage || attributes.pagination.currentPage;
        totalPages = totalPages || attributes.pagination.totalPages;

        selectors.pagiBtns.forEach(btn => {
            const page = btn.dataset.page;
            if(page === 'prev' || page === 'first'){
                if(currentPage === 1) btn.disabled = true;
                else btn.disabled = false;
            }
            if(page === 'next' || page === 'last'){
                if(currentPage === totalPages) btn.disabled = true;
                else btn.disabled = false;
            }
            if(page == currentPage) btn.classList.add('active');
            else btn.classList.remove('active');
        });
    }

    MakeCollection.prototype.openProductDetailsModal = async function(evt){
        const productId = evt.currentTarget.dataset.id;
        if(!productId) return;
        const product = attributes.makeFilteredProducts.find(p => p.product_id == productId);
        if(!product) return;

        if(!product.youtube_video_id && !product.pdf && !product.product_sku){
            window.location.href = attributes.makeNRCPageURL;
            return;
        }

        _theme.Helpers.showLoader(1);

        if(attributes.makeSku && attributes.makeSku[product.product_sku]){
            this.updateMakeVideoModal(product, {status: true, response: attributes.makeSku[product.product_sku]});
            showModel();
            return;
        }

        try {
            const savedMakes = this.getSavedData();
            const savedSkuProducts = savedMakes && savedMakes[this.make][product.product_sku];
            if(savedSkuProducts && savedSkuProducts.products){
                this.updateMakeVideoModal(product, {status: true, response: savedSkuProducts.products});
                showModel();
                return;
            }

            const resp = await this.fetchProductsBySku(product.product_sku);
            let avaialbleProducts = []; const notAvailableProducts = [];
            resp.response.forEach(p => {
                const matchedProduct = attributes.makeFilteredProducts.find(mp => mp.product_id == p.product_id);
                if(matchedProduct) avaialbleProducts.push(matchedProduct);
                else notAvailableProducts.push(p);
            });

            if(notAvailableProducts.length){
                const resultProducts = await this.filterAndExtendMakeProducts(notAvailableProducts);
                avaialbleProducts = [...avaialbleProducts, ...resultProducts];
            }
            
            // const products = await this.fetchProductsMetaByView(resp.response.slice(0,attributes.requestPerPageLimit));
            this.updateMakeVideoModal(product, {status: true, response: avaialbleProducts});
            showModel();
        } catch(err){
            _theme.Helpers.showToastMsg('Something went wrong. Please try again by reloading the page');
            // _theme.Helpers.showToastMsg('Error: '+ err.message);
            console.error(err);
            _theme.Helpers.showLoader();
        }

        function showModel(){
            document.documentElement.classList.add('scroll-stop');
            _theme.Helpers.showLoader();
            selectors.makeVideoModal.setAttribute('aria-hidden', false);
        }
    }

    MakeCollection.prototype.closeProductDetailsModal = function(){
        selectors.makeVideoModalIframe.parentElement.classList.add(attributes.hideClass);
        selectors.makeVideoModalImage.parentElement.classList.add(attributes.hideClass);
        document.documentElement.classList.remove('scroll-stop');
        selectors.makeVideoModal.setAttribute('aria-hidden', true);
    }

    MakeCollection.prototype.updateFilteredProductsCount = function(count){
        attributes.filteredProductCount = count
        selectors.filteredProductCount.innerHTML = count;
    }

    MakeCollection.prototype.updateMakeVideoModal = function(product, resp){
        if(!product) {
            console.error('Invalid Product Object');
            return;
        }

        let hasYoutube = true;
        let hasPdf = true;
        selectors.makeVideoModalTitle.innerHTML = product.year_range_title || product.product_title;

        // Handle Youtube
        const youtubeId = product.youtube_video_id.replace('https://youtu.be/','');
        if(youtubeId){
            hasYoutube = true;
            selectors.makeVideoModalIframe.setAttribute('data-id',product.youtube_video_id);
            selectors.makeVideoModalIframe.src = attributes.Youtube_Embed_URL + youtubeId;
            selectors.makeVideoModalIframe.parentElement.classList.remove(attributes.hideClass);
        } else {
            hasYoutube = false;
            selectors.makeVideoModalIframe.src = '';
            selectors.makeVideoModalIframe.parentElement.classList.add(attributes.hideClass);
            // selectors.makeVideoModalImage.src = product.image_url;
            // selectors.makeVideoModalImage.alt = product.product_title;
            // selectors.makeVideoModalImage.parentElement.classList.remove(attributes.hideClass);
        }       

        // Handle PDF
        if(product.pdf && product.pdf.includes('?v=')){
            hasPdf = true;
            selectors.makeVideoModalPdf.querySelector('p span').textContent = product.product_sku;
            selectors.makeVideoModalPdf.querySelector('a').href = product.pdf;
            selectors.makeVideoModalPdf.classList.remove(attributes.hideClass);
        } else {
            selectors.makeVideoModalPdf.classList.add(attributes.hideClass);
            hasPdf = false;
        }

        // Handle SKU
        if(hasYoutube || hasPdf) selectors.makeVideoModalNRC.classList.add('hide');
        else selectors.makeVideoModalNRC.classList.remove('hide');

        if(!resp || !resp.status){
            selectors.makeRelatedProduct.classList.add(attributes.hideClass);
            return;
        }

        const savedMakes = this.getSavedData() || {};
        savedMakes[this.make] = savedMakes[this.make] || {};
        savedMakes[this.make][product.product_sku] = savedMakes[this.make][product.product_sku] || {};
        savedMakes[this.make][product.product_sku]['products'] = resp.response;
        attributes.makeSku = attributes.makeSku || {};
        attributes.makeSku[product.product_sku] = resp.response;
        this.saveData(savedMakes);
        this.buildProductsGrid(resp.response);
    }

    MakeCollection.prototype.saveData = function(savedMakes){
        if(!savedMakes) return;
        if(attributes.PRODUCTS_LS_KEY_DURATION <= 0) {
            _theme.Helpers.eraseCookie(attributes.PRODUCTS_LS_KEY);
            _theme.Helpers.removeItemFromLS(attributes.PRODUCTS_LS_KEY);
            return;
        }

        const respData = savedMakes; //window.btoa(savedMakes);
        _theme.Helpers.setItemIntoLS(attributes.PRODUCTS_LS_KEY, respData);
        return true;
    }

    MakeCollection.prototype.getSavedData = function(){
        if(attributes.PRODUCTS_LS_KEY_DURATION <= 0) {
            _theme.Helpers.eraseCookie(attributes.PRODUCTS_LS_KEY);
            _theme.Helpers.removeItemFromLS(attributes.PRODUCTS_LS_KEY);
            return null;
        }

        return _theme.Helpers.getItemFromLS(attributes.PRODUCTS_LS_KEY);
    }

    return MakeCollection;
})();

window.addEventListener('DOMContentLoaded', evt => {
    new _theme.MakeCollection();
});